var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4158 32.9445C16.4932 28.3027 22.2568 24.8949 28.6406 24.8949C35.0244 24.8949 40.788 28.3027 44.8655 32.9445C48.9468 37.5908 51.6406 43.7999 51.6406 50.0002V53.0002H5.64062V50.0002C5.64062 43.7999 8.33446 37.5908 12.4158 32.9445ZM11.9212 47.0002H45.3601C44.7009 43.4077 42.9138 39.8143 40.3576 36.9042C37.0823 33.1755 32.8459 30.8949 28.6406 30.8949C24.4353 30.8949 20.1989 33.1755 16.9236 36.9042C14.3674 39.8143 12.5804 43.4077 11.9212 47.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1679 8.78955C24.7192 8.78955 21.1152 12.3936 21.1152 16.8422C21.1152 21.2908 24.7192 24.8948 29.1679 24.8948C33.6165 24.8948 37.2205 21.2908 37.2205 16.8422C37.2205 12.3936 33.6165 8.78955 29.1679 8.78955ZM15.1152 16.8422C15.1152 9.07986 21.4055 2.78955 29.1679 2.78955C36.9302 2.78955 43.2205 9.07986 43.2205 16.8422C43.2205 24.6045 36.9302 30.8948 29.1679 30.8948C21.4055 30.8948 15.1152 24.6045 15.1152 16.8422Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ac9ac13360031ad41794c41a795b7993.svg";
export { ForwardRef as ReactComponent };